import { clsx } from 'clsx';
import Image from 'next/image';
import React from 'react';
import { useIntl } from 'react-intl';

import StaysBgPattern from '@/assets/blog/stays-bg-pattern.png';
import Heading from '@/components/switchback/Heading/Heading';
import Icon from '@/components/switchback/Icon/Icon';
import { ICONS, IconSize } from '@/components/switchback/Icon/Icon.constants';
import Link, { LinkVariants } from '@/components/switchback/Link/Link';
import { OptimizelyFlags, useOptimizelyDecision } from '@/services/experiments';
import { getBlogBannerDataFromOptimizely } from '@/services/experiments/blogStaysBanner';

import css from './BlogStaysBanner.module.css';

interface IProps {
  blogPost?: boolean;
}

const BlogStaysBanner: React.FC<IProps> = ({ blogPost }) => {
  const intl = useIntl();
  const blogStaysBannerDecision = useOptimizelyDecision(OptimizelyFlags.BLOG_BANNER);
  const blogStaysBannerData = getBlogBannerDataFromOptimizely(blogStaysBannerDecision);

  if (!blogStaysBannerData) return null;

  const { banner_cta_url, banner_title, banner_cta_copy } = blogStaysBannerData;

  return (
    <Link
      href={banner_cta_url}
      target="_blank"
      variant={LinkVariants.noUnderline}
      className={clsx(css.wrapper, {
        [css.blogPost as string]: blogPost,
      })}>
      <Image
        alt=""
        src={StaysBgPattern}
        role="presentation"
        layout="fill"
        objectFit="cover"
        objectPosition="center"
        priority={true}
      />
      <div className={css.container}>
        <Heading level={2} className={css.title}>
          {banner_title}
        </Heading>

        <button className={css.link}>
          <span>
            {banner_cta_copy || intl.formatMessage({ defaultMessage: 'Learn more.', id: 'hl3R0S' })}
          </span>
          <Icon name={ICONS.ARROW_RIGHT} size={IconSize.normal} />
        </button>
      </div>
    </Link>
  );
};

export default BlogStaysBanner;
